//const Backofficebff         : string = "/backofficebff/service/api/v1";
const Backofficebff: any = import.meta.env.VITE_BACKOFFICEBFF!;

export const CargoPrioritizationQuery: any = {
    GetShippingCompanyRedirectManagement: Backofficebff + '/v1/cargopriorty/get-shipping-company-redirect-management',
};
